// Categorizes Sentry messages so they can be filtered/alerted on in Sentry
// by prefix, independent of the free-text message that follows.
export enum SentryMessageCategory {
  FORMS_SUBMISSION = 'FORMS_SUBMISSION',
  WEBSITE_BACKEND_CONNECTION = 'WEBSITE_BACKEND_CONNECTION',
  BOOKING_FALLBACK = 'BOOKING_FALLBACK',
  NEWSLETTER_SUBSCRIPTION = 'NEWSLETTER_SUBSCRIPTION',
  MAGAZINE_CONTENT_SETUP = 'MAGAZINE_CONTENT_SETUP',
  BREADCRUMB_CONTENT_SETUP = 'BREADCRUMB_CONTENT_SETUP',
}

const CATEGORY_PREFIXES: Record<SentryMessageCategory, string> = {
  [SentryMessageCategory.FORMS_SUBMISSION]: '[SH Gateway API - Forms]',
  [SentryMessageCategory.WEBSITE_BACKEND_CONNECTION]:
    '[Website - Backend Connection]',
  [SentryMessageCategory.BOOKING_FALLBACK]: '[Booking - Timeslot Fallback]',
  [SentryMessageCategory.NEWSLETTER_SUBSCRIPTION]: '[Newsletter]',
  [SentryMessageCategory.MAGAZINE_CONTENT_SETUP]: '[Magazine - Content Setup]',
  [SentryMessageCategory.BREADCRUMB_CONTENT_SETUP]:
    '[Breadcrumbs - Content Setup]',
};

export function withSentryCategory(
  category: SentryMessageCategory,
  message: string,
): string {
  return `${CATEGORY_PREFIXES[category]} ${message}`;
}
